import React, { useState, useEffect } from 'react';
import { render } from 'react-dom';
import Moment from 'moment';
import { handleBrowserBack } from '../../BrowserBack';
import { Tab, Nav } from 'react-bootstrap';
import TopHeading from '../../molecules/TopHeading';
import NewApplication from '../../templates/NewApplication';
import ApplicationStatusList from '../../templates/ApplicationStatusList';
import ContractedList from '../../templates/ContractedList';
import axios from '../../axios';
import { Reception, InformationItem } from '../../types/ProjectList';
import LoadingModal from '../../molecules/LoadingModal';
import GuideList from '../../templates/GuideList';
import Paragraph from '../../molecules/Paragraph';
import { KWANKGM00150A03 } from '../../const/api_modules';
import { information_max_count } from '../../const/ProjectListCustomer';
import MaintenanceMessage from '../../molecules/MaintenanceMessage';

interface KWANKGM00150A03ListItem {
  id: number;
  office: string;
  title: string;
  start_date: string;
}

const ProjectListApplicantImpl: React.FC = () => {
  const [attention, setAttention] = useState(0);
  const [receptions, setReceptions] = useState<Reception>();
  const [informations, setInformations] = useState<InformationItem[]>([]);
  const [new_informations, setNewInformations] = useState(0);
  const [info_notice, setInfoNotice] = useState('');
  const node = document.getElementById('project-list-applicant-impl');
  const jacode = node?.dataset.jacode;
  const login_user_id = node?.dataset.login_user_id;
  const is_corporate = node?.dataset.is_corporate ? true : false;
  // ローディング画面表示制御
  const [is_loading, setIsLoading] = useState(false);
  // ご案内情報ローディング表示制御
  const [is_info_loading, setIsInfoLoading] = useState(false);

  useEffect(() => {
    // ブラウザの戻る・進む禁止
    handleBrowserBack();
    getUserReceptions();
    getInformation();
  }, []);

  // ログイン中ユーザの案件情報を取得する
  const getUserReceptions = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(
        `${location.origin}${process.env.MIX_MOCK_URL}/api/get_user_receptions`
      );
      setReceptions(response.data.detail.receptions);
      setAttention(response.data.detail.attention_count);
      setInfoNotice(response.data.detail.info_notice);
    } catch (error) {
      console.error(error);
      alert(error.response.data.message);
    } finally {
      setIsLoading(false);
    }
  };

  // ご案内一覧を取得する
  const getInformation = async () => {
    try {
      setIsInfoLoading(true);

      const response = await axios.post(`${location.origin}${process.env.MIX_MOCK_URL}/api/common`,{
        reception_id: '0',
        reception_cd: null,
        module_name: KWANKGM00150A03,
        detail: [
          { id: 0, name: 'user_id', value: login_user_id }
        ]
      });

      if (!response.data.result) {
        throw({response: response});
      }

      // 顧客宛文書のリストが0件の場合は表示するリストを空にして早期リターン
      if (response.data.detail.list[0].length === 0) {
        setInformations([]);
        return;
      }

      // 顧客宛文書の件数を100件に丸める
      let information_list: InformationItem[] = [];
      response.data.detail.list.map((data: KWANKGM00150A03ListItem, index: number) => {
        if (index < information_max_count) {
          information_list.push(data);
        }
      });

      setInformations(information_list);

      // 新着件数をカウントする
      const limit_date = Moment(new Date()).subtract(7, 'd');
      let new_count = 0;
      response.data.detail.list.map((item: InformationItem) => {
        const date = Moment(item.start_date);
        if (date.isSameOrAfter(limit_date, 'day')) {
          new_count += 1;
        }
      });
      setNewInformations(new_count);
    } catch (error) {
      console.error(error);
      alert(error.response.data.message);
    } finally {
      setIsInfoLoading(false);
    }
  };

  return (
    <>
      <TopHeading label="マイページ" />
      <div className="project-list-container">
        {new_informations !== 0 && <Paragraph label="お知らせがございますので、ご案内一覧タブをご確認下さい。" css_class="new_information" bold={true} is_paragraph={true} />}
        <MaintenanceMessage message={info_notice} />
        <Tab.Container defaultActiveKey="1">
          <Nav variant="tabs">
            <Nav.Item>
              <Nav.Link eventKey="1">
                ご案内一覧
                {new_informations !== 0 && <span className="attention">{new_informations}</span>}
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="2">新規のお申込み</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="3">
                お申込み状況一覧
                {attention !== 0 && <span className="attention">{attention}</span>}
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="4">契約済一覧</Nav.Link>
            </Nav.Item>
          </Nav>
          <Tab.Content>
            <Tab.Pane eventKey="1">
              <GuideList datas={informations} />
            </Tab.Pane>
            <Tab.Pane eventKey="2">
              <NewApplication jacode={jacode} is_corporate={is_corporate} />
            </Tab.Pane>
            <Tab.Pane eventKey="3">
              <ApplicationStatusList receptions={receptions} />
            </Tab.Pane>
            <Tab.Pane eventKey="4">
              <ContractedList receptions={receptions?.contract_complete} />
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </div>
      <LoadingModal show={is_loading || is_info_loading} />
    </>
  );
};

if (document.getElementById('project-list-applicant-impl')) {
  render(<ProjectListApplicantImpl />, document.getElementById('project-list-applicant-impl'));
}
